<template>
  <VDropdown
    label="Date"
    class="slim"
    :model-value="modelValue"
    :options="options"
    @update:model-value="emitUpdateModelValue"
  />
</template>

<script lang="ts" setup>
  // Types
  import type { IVDropdownOption } from '~/misc/v-dropdown/types';

  // Components
  import VDropdown from '~/misc/v-dropdown';

  defineProps({
    modelValue: {
      type: String,
      default: undefined,
    },
    options: {
      type: Array as PropType<IVDropdownOption<string, string | undefined>[]>,
      required: true,
    },
  });

  const emit = defineEmits<{
    (e: 'update:modelValue', value: string): void;
  }>();

  const emitUpdateModelValue = (value: string) => emit('update:modelValue', value);
</script>
